import { DeepDiveSection, SummaryPoint } from '../types';

/**
 * Strips markdown formatting from text
 */
export function stripMarkdown(text: string): string {
  return text
    .replace(/#{1,6}\s+/g, '') // Remove headers
    .replace(/\*\*(.+?)\*\*/g, '$1') // Remove bold
    .replace(/\*(.+?)\*/g, '$1') // Remove italic
    .replace(/\[(.+?)\]\(.+?\)/g, '$1') // Remove links
    .replace(/`(.+?)`/g, '$1') // Remove inline code
    .replace(/^[-*+]\s+/gm, '') // Remove list markers
    .replace(/^\d+\.\s+/gm, '') // Remove numbered list markers
    .replace(/\n{3,}/g, '\n\n') // Normalize multiple newlines
    .trim();
}

/**
 * Extracts plain text from AI insights content for copying
 */

export function extractPlainTextFromDrawer(
  summaryText: string,
  summaryPoints: SummaryPoint[],
  deepDivePoints: DeepDiveSection[],
  conclusion: string,
): string {
  const parts: string[] = [];

  // Add summary
  if (summaryText) {
    parts.push('Summary');
    parts.push(summaryText);
    parts.push('');
  }

  // Add summary points
  if (summaryPoints.length > 0) {
    summaryPoints.forEach((point, index) => {
      parts.push(`${index + 1}. ${point.title}`);
      parts.push(point.summary);
      parts.push('');
    });
  }

  // Add deep dive sections
  if (deepDivePoints.length > 0) {
    parts.push('Deep Dive');
    parts.push('');
    deepDivePoints.forEach((section, index) => {
      parts.push(`${index + 1}. ${section.header}`);
      parts.push('');
      parts.push('Overview');
      parts.push(stripMarkdown(section.overview_paragraph));
      parts.push('');
      parts.push('What This Means');
      parts.push(stripMarkdown(section.what_this_means_paragraph));
      parts.push('');
      parts.push('What To Look Out For');
      parts.push(stripMarkdown(section.what_to_look_out_for_paragraph));
      parts.push('');
    });
  }

  // Add conclusion
  if (conclusion) {
    parts.push('Conclusion');
    parts.push(stripMarkdown(conclusion));
  }

  return parts.join('\n');
}
